import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  removeWatermark: false,
  watermarkPosition: {
    left: 0,
    top: 0,
  },
};

export const trialSlice = createSlice({
  name: 'trial',
  initialState: { ...initialState },
  reducers: {
    setRemoveWatermark: (state, action) => {
      state.removeWatermark = action.payload;
    },
    setWatermarkPosition: (state, action) => {
      state.watermarkPosition = action.payload;
    },
  },
});

export const { setRemoveWatermark, setWatermarkPosition } = trialSlice.actions;
export default trialSlice.reducer;
